import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Output, Input, EventEmitter } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { UserTypeManagerService, UserType } from "../services/usertype/user-type-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import { environment } from '../../../environments/environment';
import { LogService } from "../services/log/log.service";

import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";

declare var tinymce: any;
declare var $;

@Component({
    selector: "dskl-wb-text",
    templateUrl: 'text-wb.component.html',
    inputs: ["board"],
    outputs: ["change", "onCurrentState"]
})

export class TextWbComponent extends WhiteBoardComponent {

    @Input() elementId: String;
    // @Output() onEditorKeyup = new EventEmitter<any>();


    constructor(protected log: LogService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService, private userTypeManager: UserTypeManagerService, protected layoutService: LayoutManagerService, protected permissionsManager: PermissionsManagerService) {
        super(log, wbService, sessionManager, layoutService, permissionsManager);
        console.log('..constructing text board')
    }


    pageName = "TEXT"
    editor;



    onState(state, pageId) {
        console.log("--onState")
        if (pageId != this.board.pageId) {
            console.log("Not for me " + this.board.pageId + " but for " + pageId);
            console.log(state);
            return;
        }
        if (state && state.data && pageId == this.board.pageId) {
            let that = this;
            setTimeout(function () {
                //because tinymce crashes without timeout
                that.editor.setContent(state.data);
            }, 200)
        }

    }

    onViewReady() {

    }

    onReady() {

    }

    getWbType() {
        return this.pageName;
    }

    ngAfterViewInit() {
        let currentLanguagePath
        if (environment.lng == "bg") {
            currentLanguagePath = 'assets/tinymce/langs/bg_BG.js'
        } else if (environment.lng == "de") {
            currentLanguagePath = 'assets/tinymce/langs/de.js'
        } else if (environment.lng == "ru") {
            currentLanguagePath = 'assets/tinymce/langs/ru.js';
        }else{
            currentLanguagePath = null
        }

        let initialHeight = this.calculateHeight()

        tinymce.init({
            selector: '#' + this.elementId,
            plugins: ['paste', 'table', 'lists'],
            skin_url: 'assets/tinymce/skins/lightgray',
            menubar: false,
            statusbar: false,
            language_url: currentLanguagePath,
            height: initialHeight + "px",
            toolbar: 'insertfile undo redo | fontselect | fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent  |  table ',
            fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            font_formats: 'Arial=arial,helvetica,sans-serif;Courier New=courier new,courier,monospace;Times New Roman=times new roman,monospace;',
            setup: editor => {               
                this.editor = editor;                
                this.editor.on('change', () => {
                    this.emitChanged({ data: this.editor.getContent() })
                });
                this.editor.on('keyup', () => {
                    this.emitChanged({ data: this.editor.getContent() })
                });
                setTimeout(function(){
                    $(".mce-tinymce").css("border-width", "0");
                    $(".mce-branding-powered-by").hide();
                }, 1000);
            }
        });       
    }

    getCurrentState() {
        console.log('content is ', this.editor.getContent())
        return { data: this.editor.getContent() };
    }

    onCurrentPageState(received, pageId) {
        console.log('$currentPageState is ', received)
        if (received && received.data && pageId == this.board.pageId) {
            let that = this;
            setTimeout(function () {
                //because tinymce crashes without timeout
                that.editor.setContent(received.data);
            }, 200)
        }

    }

    private calculateHeight() {
        var height = this.getResizeTopOffset();
        var footerHeight = $("footer").height()
        height += footerHeight
        // var laneHeight = $(".lane").height();
        // height += laneHeight
        var h = window.innerHeight - height -25;
        return h;
    }

    onResize() {
        var h = this.calculateHeight()
        $("#" + this.elementId).css("height", h);
        console.log("Code board will resize to ", h)

    }

    ngOnDestroy() {
        try {
            tinymce.remove(this.editor);
        } catch (e) {
            console.log("On destroy ", e);
        }
    }


}



// WEBPACK FOOTER //
// /app/src/app/wb/text/text-wb.component.ts